import { Damage } from '@/types';
import { Modal } from 'antd';
import React, { FC } from 'react';
import { DamageActionsGrid } from './DamageActionsGrid';
import { useTranslate } from '@/translations';
import { DamageLabourGrid } from './DamageLabourGrid';

interface AddDamageActionsPopupProps {
  inspectionId: number;
  damageLines: Damage[];
  preferredDamageLineIds?: number[];
  isLabour: boolean;
  visible: boolean;
  canEditFr?: boolean;
  canEditParts?: boolean;
  damageLinesLoading?: boolean;
  onSubmit: () => void | Promise<unknown>;
  onClose: () => void;
  afterClose?: () => void;
}
export const AddDamageActionsPopup: FC<AddDamageActionsPopupProps> = ({
  inspectionId,
  damageLines,
  preferredDamageLineIds,
  isLabour,
  visible,
  canEditFr,
  canEditParts,
  damageLinesLoading,
  onSubmit,
  onClose,
  afterClose,
}) => {
  const { t } = useTranslate();
  return (
    <Modal
      open={visible}
      title={`Add ${isLabour ? t('labour') : t('frCodes')}`}
      width="80%"
      onCancel={onClose}
      afterClose={afterClose}
      footer={null}
    >
      {isLabour ? (
        <DamageLabourGrid
          inspectionId={inspectionId}
          damageLines={damageLines}
          preferredDamageLineIds={preferredDamageLineIds}
          canEditFr={canEditFr}
          canEditParts={canEditParts}
          damageLinesLoading={damageLinesLoading}
          onSubmit={async () => {
            await onSubmit();
            onClose();
          }}
        />
      ) : (
        <DamageActionsGrid
          inspectionId={inspectionId}
          damageLines={damageLines}
          preferredDamageLineIds={preferredDamageLineIds}
          autoFocusCode
          canEditFr={canEditFr}
          canEditParts={canEditParts}
          damageLinesLoading={damageLinesLoading}
          onSubmit={async () => {
            await onSubmit();
            onClose();
          }}
        />
      )}
    </Modal>
  );
};
